import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as TesterService from '_services/tester-service';
const initialState = {
    tester: null,
    status: 'idle',
    error: null
};

// post a new tester
export const postTester = createAsyncThunk('tester/postTester', async (tester) => {
    return TesterService.postTester(tester);
});

const testerSlice = createSlice({
    name: 'tester',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: {
        [postTester.pending]: (state, action) => {
            return {
              ...state,
              status: 'loading',
            }
        },
        [postTester.fulfilled]: (state, action) => {
            return {
              ...state,
              status: 'succeeded',
            }
        },
        [postTester.rejected]: (state, action) => {
            return {
              ...state,
              status: 'failed',
              error: action.error.message,
            }
        }
    }
});

export const { reset } = testerSlice.actions;
export const selectTester = state => state.tester.tester;
export const selectTesterStatus = state => state.tester.status;
export default testerSlice.reducer;
